import { GenericForm, GenericFormBGContainer } from "@/components/GenericForm";
import { Divider } from "@/components/misc";
import { UseFormRegister } from "react-hook-form";
import { Control } from "react-hook-form";
import { FieldErrors } from "react-hook-form";
import { RFIFormData } from "./RFIForm";
import { FormFetchDataProps } from "@/components/_Shared/Form/Interfaces/FormFetchData";
import { SearchSelect } from "@/components/_Shared/Form/Inputs/SearchSelect";
import { FormGroup } from "@/components/_Shared/Form/Containers/FormGroup";
import { FormChild } from "@/components/_Shared/Form/Containers/FormGroup";
import { Input } from "@/components/_Shared/Form/Inputs/Input";
import { TextArea } from "@/components/_Shared/Form/Inputs/TextArea";
import { Submit } from "@/components/_Shared/Form/Buttons/Submit";
import { Button } from "@/components/_Shared/Button";
import { useNavigate } from "react-router-dom";
import { Checkbox } from "@/components/_Shared/Form/Inputs/Checkbox";

type RFIFormBaseProps = {
    errors: FieldErrors<RFIFormData>
    control: Control<RFIFormData>
    register: UseFormRegister<RFIFormData>
    isProcessing: boolean
    method: "POST" | "PUT"
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
    project_list: FormFetchDataProps[]
    employee_list: FormFetchDataProps[]
    category_list: FormFetchDataProps[]
}

export function RFIFormBase({ errors, control, register, isProcessing, method, onSubmit, project_list, employee_list, category_list }: RFIFormBaseProps) {
    const method_string = {
        POST: "Create RFI",
        PUT: "Update RFI",
        CLOSE: "Close RFI"
    }

    const navigate = useNavigate()

    const status_options = ["Active", "Closed"].map((status) => ({value: status, label: status}))

    return (
        <GenericForm form_id="rfi_form" onSubmit={onSubmit}>
            <GenericFormBGContainer>
                <h2 className="text-2xl font-bold">{method === "POST" ? "Create" : "Update"} RFI</h2>

                <Divider />

                <SearchSelect label="Project" name="project" options={project_list} control={control} readonly={method === "PUT"} />
                {errors.project && <p className="text-red-500">{errors.project.message}</p>}

                <Input label="RFI Number" name="RFI_number" register={register} type="text" />
                {errors.RFI_number && <p className="text-red-500">{errors.RFI_number.message}</p>}
                
                <FormGroup>
                    <FormChild>
                        <SearchSelect label="Assigned By" name="created_by" options={employee_list} control={control} />
                        {errors.created_by && <p className="text-red-500">{errors.created_by.message}</p>}
                    </FormChild>
                    
                    <FormChild>
                        <SearchSelect label="Assigned To" name="assigned_to" options={employee_list} control={control} />
                        {errors.assigned_to && <p className="text-red-500">{errors.assigned_to.message}</p>}
                    </FormChild>
                </FormGroup>

                <FormGroup>
                    <FormChild>
                        <Input label="Date Received" name="date_received" type="date" register={register} />
                        {errors.date_received && <p className="text-red-500">{errors.date_received.message}</p>}
                    </FormChild>
                    
                    <FormChild>
                        <Input label="Sent Out Date" name="sent_out_date" type="date" register={register} />
                        {errors.sent_out_date && <p className="text-red-500">{errors.sent_out_date.message}</p>}
                    </FormChild>

                </FormGroup>

                <FormGroup>
                    <FormChild>
                        <SearchSelect label="Category" name="category" options={category_list} control={control} />
                        {errors.category && <p className="text-red-500">{errors.category.message}</p>}
                    </FormChild>

                    <FormChild>
                        <SearchSelect label="Status" name="status" options={status_options} control={control} />
                        {errors.status && <p className="text-red-500">{errors.status.message}</p>}
                    </FormChild>
                </FormGroup>

                <TextArea label="Description" name="description" register={register} placeholder="Enter description here..." />
                {errors.description && <p className="text-red-500">{errors.description.message}</p>}

                {method === "PUT" && <Checkbox label="Pinged" name="alert_status" register={register} />}
                
                <FormGroup>
                    <Button onClick={() => navigate("/rfi")}> Back </Button>
                    <Submit isSubmitting={isProcessing} label={method_string[method]} />
                </FormGroup>
            </GenericFormBGContainer>
        </GenericForm>
    );
}
